(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialise(root = document) {
    root.querySelectorAll('[data-bb-motion]').forEach(hero => {
      const button = hero.querySelector('[data-bb-pause]');
      if (!button || button.dataset.ready) return;
      button.dataset.ready = 'true';
      const update = paused => {
        hero.classList.toggle('bb-motion-paused', paused);
        button.setAttribute('aria-pressed', String(paused));
        const label = reducedMotion.matches ? 'Animation disabled for reduced motion' : paused ? 'Play animation' : 'Pause animation';
        button.setAttribute('aria-label', label);
        button.title = label;
        button.querySelector('[data-bb-pause-icon]').hidden = paused;
        button.querySelector('[data-bb-play-icon]').hidden = !paused;
        button.disabled = reducedMotion.matches;
      };
      update(reducedMotion.matches);
      button.addEventListener('click', () => update(!hero.classList.contains('bb-motion-paused')));
      reducedMotion.addEventListener('change', event => update(event.matches));
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-bb-flip]');
    if (!button) return;
    const card = button.closest('[data-bb-card]');
    const back = card.classList.toggle('bb-flipped');
    button.setAttribute('aria-pressed', String(back));
    button.textContent = back ? 'View front ↻' : 'View back ↻';
    button.setAttribute('aria-label', `${back ? 'View front' : 'View back'} of ${card.querySelector('h3').textContent.trim()}`);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-bb-search]');
    if (!form) return;
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
    const input = form.querySelector('input[name="q"]');
    const artist = [...form.querySelectorAll('datalist option')].find(option => normalize(option.value) === normalize(input.value));
    if (!artist) return; // All other terms keep Shopify's normal product search.
    event.preventDefault();
    const url = new URL(form.dataset.bbArtistUrl, window.location.origin);
    url.searchParams.set(form.dataset.bbArtistParam, artist.dataset.filterValue);
    window.location.assign(url.href);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
